import React, { useState, useRef }from 'react';
import { useForm } from 'react-hook-form';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import api from '../conexao.js';
import '../../App.css';
import { useNavigate} from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import InputMask from 'react-input-mask';
import logOut from '../logOut';
import SignaturePad from 'react-signature-canvas';
import './CadastroMedico.css';
import novo from '../../img/novo.jpg';
import rodape from '../../img/rodape.jpg';

export default function CadMedico(){
        const nave= useNavigate();


const {register, handleSubmit} = useForm( );  //REGISTRANDO AS FUNÇÕES DO USEFORM
const [exibirModal, setExibirModal] = useState(false); // const para definir se a modal aparece ou nao
const [tel, setTEL] = useState();
const [cel, setCEL] = useState();
const [cpf, setCPF] = useState();
const [modalMSG, setModalMSG] = useState(false);
const [MSG, setMSG] = useState();
const [cabecalho, setCabecalho] = useState();
const [rodape, setRodape] = useState();
const [tipoReceituario, setTipoReceituario] = useState('proprio');
const [alturaCabecalho, setAlturaCabecalho] = useState(30);
const [alturaRodape, setAlturaRodape] = useState(30);
const [modalPreview, setModalPreview] = useState(false);
const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
const assinatura = useRef({})
var sign;

function handleFecharModal(){
        setExibirModal(false); // inicia faalse
        nave('/medico/medico'); // vai para pagina anterior
}

function handleVoltar(){
        nave('/medico/medico');
}

var telnum = String;
var celnum = String;
var cpfnum = String;

 const onSubmit = (data) => {
         
        if  (tel)  {
                telnum = tel;
                telnum = telnum.replace(/[^0-9]+/g, "");
        }
        if (cel) {
                celnum = cel;
                celnum = celnum.replace(/[^0-9]+/g, "");
        }
        if (cpf) {
                cpfnum = cpf;
                cpfnum = cpfnum.replace(/[^0-9]+/g, "");
        }


       async function grava() { 
                
                // if (cabecalho) { data.CABECALHO = 'CAB ' + data.NOME.substring(0,10) + '.JPEG'}
                // if (rodape)    { data.RODAPE    = 'ROD ' + data.NOME.substring(0,10) + '.JPEG'}

                gravaAssinatura() 
                
                if (tipoReceituario === 'proprio') {
                    if (cabecalho) { data.CABECALHO = 'cab ' + data.NOME.substring(0,10).toLowerCase() + '.jpg'}
                    if (rodape)    { data.RODAPE    = 'rod ' + data.NOME.substring(0,10).toLowerCase() + '.jpg'}
                } else {
                    data.CABECALHO = alturaCabecalho + 'mm';
                    data.RODAPE = alturaRodape + 'mm';
                }

                // console.log(cabecalho.name)
                // console.log(rodape.name)
                                               
               await api.post('/medico', {
                NOME: data.NOME.toUpperCase(),
                ENDERECO: data.ENDERECO.toUpperCase(),
                BAIRRO: data.BAIRRO.toUpperCase(),
                CIDADE: data.CIDADE.toUpperCase(),
                TEL: telnum,
                CEL: celnum,
                CPF: cpfnum,
                CRM: data.CRM.toUpperCase(),
                CABECALHO: data.CABECALHO,
                RODAPE: data.RODAPE,
                ASSINATURA: sign

        }).then(() => setExibirModal(true))
        .catch( 
                (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
            })   
        }
        const formDataCabecalho = new FormData();
        const formDataRodape = new FormData();

        formDataCabecalho.append('file',cabecalho);
        formDataCabecalho.append('nomeFile', 'cab ' + data.NOME.substring(0,10).toLowerCase() + '.jpg')

        formDataRodape.append('file',rodape);
        formDataRodape.append('nomeFile','rod ' + data.NOME.substring(0,10).toLowerCase() + '.jpg');

        const uploadCabecalho = async () => {
                await api.post('/logo', formDataCabecalho)
        };

        const uploadRodape = async () => {
                await api.post('/logo', formDataRodape)
        };

        

   
        grava();
        if (tipoReceituario === 'proprio') {
            if (cabecalho) {uploadCabecalho();}
            if (rodape) {uploadRodape();}
        }
        



}       
function funcCabecalho(e) {
        const cabeca = e.target.files[0];
        setCabecalho(cabeca);
    }

function funcRodape(e) {
        const roda = e.target.files[0];
        setRodape(roda);
    }   

function gravaAssinatura() {
        sign = assinatura.current.toDataURL() // GRAVAR A VARIAVEL SIGN NO BANCO E RESTAURAR PARA APARECER A ASSINATURA        
}

async function previewPDF() {
    
    // Verificar se assinatura está vazia
    const hasValidSignature = !assinatura.current.isEmpty();
    
    // Verificar se receituário próprio tem imagens anexadas
    if (tipoReceituario === 'proprio') {
        if (!cabecalho && !rodape) {
            setMSG('Anexe pelo menos uma imagem (cabeçalho ou rodapé) para o receituário próprio.');
            setModalMSG(true);
            return;
        }
    }
    
    const pdfMake = require('pdfmake/build/pdfmake');
    const pdfFonts = require('pdfmake/build/vfs_fonts');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    
    gravaAssinatura();
    
    // Função para converter mm para pontos
    const mmToPoints = (mm) => Math.round(mm * 4.4);
    
    let cabecalhoHeight = 78;
    let rodapeHeight = 60;
    
    if (tipoReceituario === 'timbrado') {
        cabecalhoHeight = mmToPoints(alturaCabecalho);
        rodapeHeight = mmToPoints(alturaRodape);
    }
    
    // Verificar se há imagens carregadas
    const temImagemCabecalho = cabecalho && tipoReceituario === 'proprio';
    const temImagemRodape = rodape && tipoReceituario === 'proprio';
    
    // Converter arquivos para base64
    const fileToBase64 = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(file);
        });
    };
    
    let cabecalhoBase64, rodapeBase64;
    if (temImagemCabecalho) {
        cabecalhoBase64 = await fileToBase64(cabecalho);
    }
    if (temImagemRodape) {
        rodapeBase64 = await fileToBase64(rodape);
    }
    
    // Criar docDefinition com bordas vermelhas apenas para receituário timbrado
    const docDefinitions = {
        pageSize: 'A4',
        pageMargins: [15, Math.max(50, cabecalhoHeight + 20), 15, Math.max(50, rodapeHeight + 20)],
        header: temImagemCabecalho ? 
            { image: 'cabecalhoImg', width: 530, height: cabecalhoHeight, alignment: 'center', margin: [0, 10] } :
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 10,
                        w: 595,
                        h: cabecalhoHeight,
                        lineColor: 'red',
                        lineWidth: 2,
                        dash: { length: 5 }
                    },
                    {
                        type: 'text',
                        x: 297,
                        y: cabecalhoHeight / 2 + 15,
                        text: 'ÁREA DO CABEÇALHO',
                        fontSize: 12,
                        color: 'red',
                        alignment: 'center'
                    }
                ]
            },
        content: [
            { text: 'Receituário', fontSize: 17.5, bold: true, alignment: 'center', margin: [0, 5, 0, 0] },
            {
                columns: [
                    { text: 'Paciente: PACIENTE EXEMPLO', fontSize: 12, width: '*' },
                    { text: `Data: ${new Date().toLocaleDateString()}`, fontSize: 12, width: 'auto', alignment: 'right' }
                ],
                margin: [0, 10]
            },
            { text: 'Texto de exemplo para visualização do layout do receituário.', margin: [0, 20] },
            ...(hasValidSignature ? [{
                canvas: [{
                    type: 'rect',
                    x: 200, y: 0, w: 130, h: 75,
                    lineColor: '#ccc', lineWidth: 1
                }],
                margin: [0, 20, 0, 0]
            }, { text: 'Assinatura do Médico', fontSize: 8, alignment: 'center', margin: [0, -10, 0, 0] }] : []),
            { text: 'NOME DO MÉDICO', fontSize: 12, bold: true, alignment: 'center', margin: [0, 30, 0, 0] },
            { text: 'CRM 12345', fontSize: 10, bold: true, alignment: 'center', margin: [0, 7, 0, 0] }
        ],
        footer: function() {
            return temImagemRodape ? 
                { image: 'rodapeImg', width: 530, height: rodapeHeight, alignment: 'center', margin: [0, 0, 0, 10] } :
                {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 595,
                            h: rodapeHeight,
                            lineColor: 'red',
                            lineWidth: 2,
                            dash: { length: 5 }
                        },
                        {
                            type: 'text',
                            x: 297,
                            y: rodapeHeight / 2,
                            text: 'ÁREA DO RODAPÉ',
                            fontSize: 12,
                            color: 'red',
                            alignment: 'center'
                        }
                    ]
                };
        },
        images: {
            ...(temImagemCabecalho && { cabecalhoImg: cabecalhoBase64 }),
            ...(temImagemRodape && { rodapeImg: rodapeBase64 })
        },
        defaultStyle: {
            fontSize: 10,
            color: 'black'
        }
    };
    
    const pdfDocGenerator = pdfMake.createPdf(docDefinitions);
    pdfDocGenerator.getBlob((blob) => {
        const url = URL.createObjectURL(blob);
        setPdfPreviewUrl(url);
        setModalPreview(true);
    });
}

// function loadAssinatura(){
//         assinatura.current.fromDataURL(sign)
//         console.log(sign)
// }
    return(

        <div>
        

        <div className="cadastroMedico-formContainer">
              <h2 className="cadastroMedico-title">Cadastro do Médico</h2>
              <form onSubmit={handleSubmit(onSubmit)} className='cadastroMedico-form '>
                <div className="cadastroMedico-formGroup">
                  <label className="cadastroMedico-label">Nome:</label>
                  <input className="cadastroMedico-input" type="text" name="NOME" maxLength={45}
                  style={{textTransform:"uppercase"}} 
                  required
                  {...register('NOME',{minLength: 10})}  />
                </div>
                <div className="cadastroMedico-formGroup3">
                <label className="cadastroMedico-label">CRM:</label>
                 <Form.Control style={{textTransform:"uppercase"}} 
                    type="text" 
                    size="sm" 
                    maxLength={15}
                    name="CRM" 
                    {...register('CRM')} 
                    required
                    />
                </div>
                <div className="cadastroMedico-formGroup">
                  <label className="cadastroMedico-label">Endereço:</label>
                  <input className="cadastroMedico-input" type="text" name="ENDERECO" maxLength={45}
                   {...register('ENDERECO')}
                   style={{textTransform:"uppercase"}}  />
                </div>
                <div className="cadastroMedico-formGroup">
                  <label className="cadastroMedico-label">Bairro:</label>
                  <input className="cadastroMedico-input" type="text" name="BAIRRO" maxLength={45}
                  style={{textTransform:"uppercase"}} 
                  {...register('BAIRRO')}/>
                </div>
                <div className="cadastroMedico-formGroup">
                  <label className="cadastroMedico-label">Cidade:</label>
                  <input className="cadastroMedico-input" type="text" name="CIDADE" maxLength={45}
                  style={{textTransform:"uppercase"}}
                  {...register('CIDADE')}/>
                </div>
                <div className="cadastroMedico-formGroup3">
                  <label className="cadastroMedico-label">Tel.:</label>
                  {/* <input className="cadastroMedico-input" type="text" name="telefone" {...register('TEL')} /> */}
                         <InputMask
                                 mask="(99)9999-9999"
                                 size="24"
                                 name="TEL"
                                 {...register('TEL')}
                                 value={tel}
                                 onChange={(e) => setTEL(e.target.value)}
                                 alwaysShowMask={false}
                         /> 
                </div>
                <div className="cadastroMedico-formGroup3">
                  <label className="cadastroMedico-label">Cel.:</label>
                  {/* <input className="cadastroMedico-input" type="text" name="celular" {...register('CEL')} /> */}
                  <InputMask
                                mask="(99)99999-9999"
                                size="24"
                                name="CEL"
                                {...register('CEL')}
                                value={cel}
                                onChange={(e) => setCEL(e.target.value)}
                                alwaysShowMask={false}
                        />
                </div>
                <div className="cadastroMedico-formGroup3">
                  <label className="cadastroMedico-label">CPF:</label>
                  {/* <input className="cadastroMedico-input" type="text" name="cpf" {...register('CPF')}/> */}
                  <InputMask
                                mask="999.999.999-99"
                                size="24"
                                name="CPF"
                                {...register('CPF')}
                                value={cpf}
                                onChange={(e) => setCPF(e.target.value)}
                                alwaysShowMask={false}
                        />
                </div>
                <div className="cadastroMedico-formGroup">
                    <label className="cadastroMedico-label">Tipo de Receituário:</label>
                    <div>
                        <Form.Check 
                            type="radio"
                            label="Receituário Próprio (com imagens)"
                            name="tipoReceituario"
                            checked={tipoReceituario === 'proprio'}
                            onChange={() => setTipoReceituario('proprio')}
                        />
                        <Form.Check 
                            type="radio"
                            label="Receituário Timbrado (espaçamento)"
                            name="tipoReceituario"
                            checked={tipoReceituario === 'timbrado'}
                            onChange={() => setTipoReceituario('timbrado')}
                        />
                    </div>
                </div>
                
                {tipoReceituario === 'proprio' && (
                    <>
                        <div className="cadastroMedico-formGroup3">
                            <label className="cadastroMedico-label">Cabeçalho</label>
                            <Form.Control  
                                type="file" name="cabecalho" accept="image/jpeg"
                                onChange={e => funcCabecalho(e)} 
                            />
                        </div>
                        <br/>
                        <div className="cadastroMedico-formGroup3">
                            <label className="cadastroMedico-label">Roda-pé</label>
                            <Form.Control
                                type="file" name="rodape" accept="image/jpeg"
                                onChange={e => funcRodape(e)}
                            />
                        </div>
                    </>
                )}
                
                {tipoReceituario === 'timbrado' && (
                    <>
                        <div className="cadastroMedico-formGroup3">
                            <label className="cadastroMedico-label">Altura do Cabeçalho</label>
                            <InputGroup>
                                <InputGroup.Text>mm</InputGroup.Text>
                                <Form.Control
                                    type="number"
                                    placeholder="mm"
                                    min="30"
                                    max="70"
                                    value={alturaCabecalho}
                                    onChange={e => setAlturaCabecalho(e.target.value)}
                                />
                            </InputGroup>
                        </div>
                        <div className="cadastroMedico-formGroup3">
                            <label className="cadastroMedico-label">Altura do Rodapé</label>
                            <InputGroup>
                                <InputGroup.Text>mm</InputGroup.Text>
                                <Form.Control
                                    type="number"
                                    placeholder="mm"
                                    min="10"
                                    max="70"
                                    value={alturaRodape}
                                    onChange={e => setAlturaRodape(e.target.value)}
                                />
                            </InputGroup>
                        </div>
                    </>
                )}
                 
                <div className="cadastroMedico-formGroup3">
                 <label className="cadastroMedico-label">Assinatura</label>
                <div style={{borderStyle: "solid", borderWidth: "1px", width:"320px"}}>
                        <SignaturePad  ref={assinatura} canvasProps={{width: 320, height: 200}}/>    
                                  
                         </div>
                         <Button className="btn btn-warning"  onClick={()=> {assinatura.current.clear()}}>Limpar</Button>  
                          {/* <Button className="btn btn-warning"  onClick={()=> {gravaAssinatura()}}>grava</Button> */}
                         {/* <Button className="btn btn-warning"  onClick={()=> {loadAssinatura()}}>open</Button>  */}
                </div>
                <div className="cadastroPaciente-formActions">
                  <Button className="btn-primary"  type="submit">Gravar</Button>
                  <Button className="btn-info" onClick={previewPDF}>Visualizar PDF</Button>
                  <Button className="btn-secondary" 
                  onClick={() => {handleVoltar()}}  type="submit">Cancelar</Button>
                </div> 
             </form>
        </div>

        <Modal show={exibirModal} onHide={handleFecharModal} backdrop="static">
                <Modal.Header>
                        <h2> Cadastro Médico </h2>
                </Modal.Header>
                <Modal.Body>
                        Médico Gravado!
                </Modal.Body>
                <Modal.Footer>
                        <Button variante="success" onClick={() => handleFecharModal()}> Ok </Button>
                </Modal.Footer>
                
        </Modal>
        <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 
            
        <Modal show={modalPreview} size="lg" centered onHide={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null); setModalPreview(false);}}>
            <Modal.Header closeButton> 
                <h3>Visualização do Layout</h3>
            </Modal.Header> 
            <Modal.Body>
                {pdfPreviewUrl && <iframe src={pdfPreviewUrl + '#toolbar=0'} style={{width: '100%', height: '600px', border: 'none'}} title="Preview PDF"></iframe>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null); setModalPreview(false);}}>Fechar</Button>
            </Modal.Footer>
        </Modal>

        </div>
        
    )
};


